import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";

import { useGetGenderwiseEmployeeForAllQuery, useGetGenderwiseEmployeeQuery } from "app/services/RTK_Apis/dashbords/HomeDefaultApi";

function FourthChart({ partnerName, companyId, businessUnit, isMobile }) {
  const theme = useTheme();

const { data: genderAllData } =
  useGetGenderwiseEmployeeForAllQuery(undefined, {
    skip: businessUnit !== "All BU",
  });

const { data: genderPartnerData } =
  useGetGenderwiseEmployeeQuery(partnerName, {
    skip: businessUnit === "All BU" || !partnerName,
  });

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "50%",
          dataLabels: { position: "top" },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val,
        style: { fontSize: "12px", colors: [theme.palette.text.primary] },
      },
      xaxis: {
        categories: [],
        title: { text: "Number of Employees", style: { fontSize: "12px" } },
      },
      yaxis: {
        title: { text: "", style: { fontSize: "12px" } },
      },
      colors: ["#2196F3", "#FF4081"],
      tooltip: { theme: "light" },
      responsive: [
        {
          breakpoint: 768,
          options: { plotOptions: { bar: { barHeight: "40%" } } },
        },
        {
          breakpoint: 480,
          options: { plotOptions: { bar: { barHeight: "35%" } } },
        },
      ],
    },
  });

 useEffect(() => {

  const apiData =
    businessUnit === "All BU"
      ? genderAllData
      : genderPartnerData;

  if (!apiData) return;

  const categories = apiData.map((item) => item.Gender);
  const counts = apiData.map((item) => Number(item.Count));

  setChartData((prev) => ({
    ...prev,
    series: [{ name: "Employees", data: counts }],
    options: {
      ...prev.options,
      xaxis: { ...prev.options.xaxis, categories },
    },
  }));

}, [genderAllData, genderPartnerData, businessUnit]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: { xs: 1, sm: 1 },
        width: "100%",
      }}
    >
      <Typography
        variant={isMobile ? "subtitle1" : "h5"}
        fontWeight={600}
        sx={{ mb: 1, textAlign: "center" }}
      >
        Gender Wise Employees
      </Typography>

      {chartData.series?.length > 0 && chartData.series[0].data.length > 0 ? (
        <Box sx={{ width: "100%", maxWidth: isMobile ? 280 : 400 }}>
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={isMobile ? 200 : 260}
          />
        </Box>
      ) : (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, textAlign: "center", mt: 2 }}
        >
          Nothing to preview
        </Typography>
      )}
    </Box>
  );
}

export default FourthChart;
